import axios from '../../../../../api/axios';

export const initialState = {
  commission: {},
  commissions: [],
  error: {},
  isLoaded: false,
  page: null,
};

export const reducer = (state, actions) => {
  const { payload, type } = actions;
  switch (type) {
    case 'LOADED':
      return { ...state, isLoaded: true };
    case 'LOADING':
      return { ...state, isLoaded: false };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    case 'CHANGE_FIELD':
      const { name, value } = payload;
      return { ...state, commission: { ...state.commission, [name]: value } };
    case 'ERROR':
      return { ...state, error: payload };
    case 'COMMISSIONS':
      return { ...state, commissions: payload, isLoaded: true };
    case 'COMMISSION':
      return { ...state, commission: payload };
    case 'COMMISSIONS_WITH_RESET_FORM':
      return { ...initialState, commissions: payload, isLoaded: true };
    case 'RESET_FORM':
      return {
        ...initialState,
        commissions: state.commissions,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export const actions = {
  fetchingCommissions: async (page = 1, limit) => {
    try {
      const { data: customers } = await axios.post(
        `/api/v1/admin/commissions/list`,
        {
          page,
          limit,
        }
      );
      return customers;
    } catch (error) {
      return new Error(error);
    }
  },
  deleteCommission: async (id) => {
    try {
      const {
        data: { messages },
      } = await axios.delete(`/api/v1/admin/commissions/${id}`);
      return messages;
    } catch (error) {
      return new Error(error);
    }
  },
};
